import styled from 'styled-components';

import { colors } from 'common/styles/style-constants';

import { StyledAlert } from '../../../checkout-styled-components';

export const PromoCodeCardContainer = styled.div`
  margin: ${(props) => (props.isMobile ? '0 0 12px 0' : '0 0 24px 0')};
`;

export const StyledAlertMessage = styled(StyledAlert)`
  && {
    height: auto;
    .ant-alert-message {
      padding: 0px;
      color: ${colors.blue};
    }

    &:hover {
      background-color: ${(props) =>
    (props.canAddOffer ? 'rgba(80, 124, 117, 0.2)' : 'none')};
    }
  }
`;

export const StyledAlertButton = styled.button`
  width: 100%;
  background: transparent;
  border: none;
  padding: 0;
`;
